import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";

export const AdministratorTicketingWebsiteAlertsNotRunRecently = () => {
    const dispatch = useDispatch();

    const [ticketingWebsiteAlertsNotRunRecently, setTicketingWebsiteAlertsNotRunRecently] = useState([]);
    const [areTicketingWebsiteAlertsNotRunRecentlyLoading, setAreTicketingWebsiteAlertsNotRunRecentlyLoading] = useState(true);
    const [loadingError, setLoadingError] = useState("");

    const [showDialog, setShowDialog] = useState(false);
    const [dialogContent, setDialogContent] = useState("");

    const ViewDialogCell = (props) => {
        const content = props.dataItem[props.field];

        return (
            <td>
                {content ? <Button fillMode="link" type={"button"} onClick={() => viewDialog(content)}>View</Button> : ""}
            </td>
        );
    };

    const viewDialog = (content) => {
        setDialogContent(content);
        setShowDialog(true);
    }

    const getTicketingWebsiteAlertsNotRunRecently = () => {
        setAreTicketingWebsiteAlertsNotRunRecentlyLoading(true);

        const dataItem = {
            
        };

        fetch(`/api/administrator/ticketingwebsitealertsnotrunrecently`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setAreTicketingWebsiteAlertsNotRunRecentlyLoading(false);                
                setTicketingWebsiteAlertsNotRunRecently(result);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setAreTicketingWebsiteAlertsNotRunRecentlyLoading(false);
                setLoadingError(error.message);
            });
    }

    useEffect(() => {
        document.title = "Ticketing Website Alerts Not Run Recently";

        getTicketingWebsiteAlertsNotRunRecently();
    }, []);

    return (
        <div>
            {areTicketingWebsiteAlertsNotRunRecentlyLoading ? <LoadingPanel /> : (loadingError === "" ? (
                <>
                    <Grid
                        data={ticketingWebsiteAlertsNotRunRecently}
                        resizable={true}                        
                        pageable={false}
                        scrollable="none"
                    >                        
                        <Column field="ticketingWebsiteAlertLabel" title={"Alert"} />
                        <Column field="ticketingWebsiteName" title={"Website"} />
                        <Column field="lastRunDate" title={"Last run date"} />
                        <Column field="wasLastRunSuccessful" title={"Last run successful"} />
                        <Column field="lastRunNotes" title={"Last run notes"} cell={ViewDialogCell} />
                    </Grid>

                    {showDialog === false ? <></> :
                        <Dialog
                            title={"Notes"}
                            onClose={() => setShowDialog(false)}
                            width={"90vw"}
                        >
                            {dialogContent}
                        </Dialog>
                    }
                </>
            ) : <></>)
            }
        </div>
    );
}